import { render, staticRenderFns } from "./ChartjsBarChartMangerClient.vue?vue&type=template&id=4c1475a5&"
import script from "./ChartjsBarChartMangerClient.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChartMangerClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports